
// General constants
export const WEB_UI_VERSION = process.env.VUE_APP_VERSION;
export const MINIMUM_CM_VERSION = "8.9.0";
export const WEB_UI_ROOT = "/webui";
export const LOGIN_ROUTE_PATH = "/login";
export const LOGOUT_ROUTE_PATH = "/logout";

// Known roles
export const USE_CLIENT_ROLE = "client.use";
export const CERT_ISSUE_ROLE = "cert.issue";
export const CERT_REVOKE_ROLE = "cert.revoke";

// Required dashboard roles
export const DASHBOARD_ROLES = [USE_CLIENT_ROLE];

// Required certificate roles
export const LIST_CERTIFICATE_ROLES = [USE_CLIENT_ROLE];
export const DOWNLOAD_CERTIFICATE_ROLES = [USE_CLIENT_ROLE];
export const CREATE_CERTIFICATE_ROLES = [USE_CLIENT_ROLE, CERT_ISSUE_ROLE];
export const REVOKE_CERTIFICATE_ROLES = [USE_CLIENT_ROLE, CERT_REVOKE_ROLE];
export const REINSTATE_CERTIFICATE_ROLES = [USE_CLIENT_ROLE, CERT_ISSUE_ROLE];

// Required registration roles
export const LIST_REGISTRATION_ROLES = [USE_CLIENT_ROLE];
export const CREATE_REGISTRATION_ROLES = [USE_CLIENT_ROLE, CERT_ISSUE_ROLE];
export const UPDATE_REGISTRATION_ROLES = [USE_CLIENT_ROLE, CERT_ISSUE_ROLE];
export const CSR_PEM_HEADER = "-----BEGIN CERTIFICATE REQUEST-----";
export const CSR_PEM_FOOTER = "-----END CERTIFICATE REQUEST-----";
export const CSR_PEM_ALT_HEADER = "-----BEGIN NEW CERTIFICATE REQUEST-----";
export const CSR_PEM_ALT_FOOTER = "-----END NEW CERTIFICATE REQUEST-----";
export const CSR_PEM_NEWLINE = "\r\n";
export const CERTIFICATE_FORMATS = [
    { type: "pkix-cert", extension: ".cer" },
    { type: "pkcs7-mime", extension: ".p7b" },
    { type: "pem-certificate-chain", extension: ".pem" },
];

export const REVOCATION_REASONS = [
    { title: "Affiliation changed", id: 3 },
    { title: "Certificate hold", id: 6 },
    { title: "Cessation of operation", id: 5 },
    { title: "Key compromise", id: 1 },
    { title: "Not specified", id: 0 },
    { title: "Privilege withdrawn", id: 9 },
    { title: "Superseded", id: 4 },
];

export const PERSONAL_INSTALL_LOCATIONS = [
    {
        userAgentRegex: "^[^(]*\\(Windows.*$",
        url: "/webui/files/windows.zip"
    },
    {
        userAgentRegex: "^[^(]*\\(Macintosh.*$",
        url: "/webui/files/macosx.zip"
    },
    {
        userAgentRegex: "^[^(]*\\(X11[^)]*Ubuntu.*$",
        url: "/webui/files/ubuntu-20_22.zip"
    }
];
